export default __webpack_public_path__ + "static/media/explore.ac13185b.svg";